import { render, staticRenderFns } from "./AzLoading.vue?vue&type=template&id=74bec8c3&"
import script from "./AzLoading.vue?vue&type=script&lang=js&"
export * from "./AzLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports